import alertActions from 'redux/alert/alertActions'

export default dispatch => (message, status = 'success') => {
  dispatch(alertActions.create(message, status))
}
